<template>
  <div class="form-builder_lookupDefault">
    <b-form-group label="Default value:">
      <multiselect
        v-model="selectedLookUps"
        :options="lookups"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :searchable="true"
        placeholder
        label="text"
        selectedLabel
        track-by="value"
        @select="save"
        @remove="save"
        :disabled="control.readonly"
        openDirection="bottom"
      />
      <b-form-input placeholder="Enter expression" v-model="control.defaultValue" />
    </b-form-group>
    <b-form-group label="Is able to add value:">
      <b-form-checkbox v-model="control.ableToAddLookUpVal">
        <span
          v-back-to-default="[
            $parent.inheritedControlInfo,
            control,
            'ableToAddLookUpVal',
            $parent.backToDefault
          ]"
        >{{ control.ableToAddLookUpVal ? "yes": "no" }}</span>
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      rowKey: null,
      cellKey: null,
      options: null,
      lookUpTable: null,
      selectedLookUps: [],
    }
  },
  watch: {
    lookups() {
      this.setLookUpVal()
    },
  },
  computed: {
    ...mapState(['dataGrid_options']),
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = []
      const lookUpTableVals = $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  methods: {
    setLookUpVal() {
      this.selectedLookUps = []

      if (!this.control.value) return

      const values = this.control.value.split(',')

      for (let value of values) {
        const lookup = find(this.lookups, { value })

        if (lookup) {
          this.selectedLookUps.push(lookup)
        } else {
          console.error(
            `[multi_lookup] - row "${value}" not found in "${this.lookUpTable}" grid`
          )
        }
      }
    },
    save(val) {
      this.$nextTick(() => {
        let selectedLookUps = this.selectedLookUps.map(lookup => lookup.value)

        this.control.defaultValue = selectedLookUps.join(',')
      })
    },
    backToDefault(prop, value) {
      this.$parent.backToDefault(prop, value)

      this.setLookUpVal()
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')
      this.gridId = formBuilderInst.gridId
      this.rowKey = formBuilderInst.rowKey
      this.cellKey = this.control.propName
      this.options = this.dataGrid_options[formBuilderInst.gridId]
      this.lookUpTable = this.dataGrid_options[this.gridId].meta[
        this.cellKey
      ].lookUpTable

      this.setLookUpVal()
    })
  },
}
</script>

<style>
.form-builder_lookupDefault + div > div:first-child {
  display: none;
}
</style>
